import { api } from "./client";
import type { User } from "./types";

export const authApi = {
  me: () => api.get<User | null>("/api/auth/me"),

  login: (email: string, password: string) =>
    api.post<User>("/api/auth/login", { email, password }),

  signup: (input: {
    email: string;
    password: string;
    display_name: string;
    invite_code: string;
  }) => api.post<User>("/api/auth/signup", input),

  logout: () => api.post<void>("/api/auth/logout"),

  logoutEverywhere: () => api.post<void>("/api/auth/logout-everywhere"),

  /** `current_password` is only needed when `email` changes. */
  updateAccount: (input: { display_name?: string; email?: string; current_password?: string }) =>
    api.patch<User>("/api/auth/me", input),

  changePassword: (current_password: string, new_password: string) =>
    api.post<void>("/api/auth/password", { current_password, new_password }),

  deleteAccount: (password: string) => api.post<void>("/api/auth/delete-account", { password }),
};
